// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1v2l7","type":"styles_type__15iBh","choices":"styles_choices__28xzz"};